/* @flow */

import placeholder from 'static/images/placeholder.png';
import videoPlaceholder from 'static/images/video-placeholder.png';

export const getImage = (
  resource?: BucketResource,
  variant: string = 'web'
) => {
  if (resource) {
    switch (resource.type.category) {
      case 'image':
        return resource.url[variant];
      case 'pdf':
        return resource.url.thumbnail;
      default:
        return null;
    }
  }

  return null;
};

export const getImageOrPlaceholder = (
  resource?: BucketResource,
  variant: string = 'web'
) => getImage(resource, variant) || placeholder;

export const getVideoPlaceholder = videoPlaceholder;



// WEBPACK FOOTER //
// ./src/utils/resources.js